<template>
  <div class="authentication-bg">
    <div class="account-pages mt-5 mb-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-6">
            <div class="card">
              <div class="card-body">
                <div class="card-header pt-4 pb-2 text-center">
                  <router-link :to="{ name: 'home' }">
                    <BaseLogo item-class="logo-lg" :height="80" />
                  </router-link>
                </div>
                <Loading :loading="isLoading" v-if="isLoading" />

                <template v-else>
                  <div class="text-center border border-dark my-2" v-if="active_tab === 2 && user">
                    <green-teak-icon class="my-2" width="75" height="75" />
                    <p class="text-dark">
                      {{ $t('views.retailer.users.register.dear', { fullname: user.fullname }) }},
                    </p>
                    <p class="text-dark">
                      {{ $t('views.retailer.users.register.registered') }}
                    </p>
                  </div>
                  <welcome-card v-if="active_tab === 1" />
                  <form @submit.prevent="submit">
                    <div id="basicwizard">
                      <ul class="nav nav-pills nav-justified form-wizard-header mb-2">
                        <li class="nav-item">
                          <a
                            href="#"
                            @click="formClickSendEvent"
                            data-toggle="tab"
                            class="nav-link rounded-0 pt-2 pb-2 disabled px-1"
                            :class="{
                              active: active_tab === 1,
                              'bg-spec': active_tab !== 1
                            }"
                          >
                            <div>
                              <i class="mdi mdi-store me-1" />
                              <span class="d-none d-sm-inline">
                                {{ $t('views.retailer.users.register.company_informations') }}
                              </span>
                            </div>
                          </a>
                        </li>
                        <li class="nav-item">
                          <a
                            href="#"
                            @click="formClickSendEvent"
                            data-toggle="tab"
                            class="nav-link rounded-0 pt-2 pb-2 disabled px-1"
                            :class="{
                              active: active_tab === 2,
                              'bg-spec': active_tab !== 2
                            }"
                          >
                            <div>
                              <i class="mdi mdi-checkbox-marked-circle-outline me-1" />
                              <span class="d-none d-sm-inline">{{
                                $t('views.retailer.users.register.company_activities')
                              }}</span>
                            </div>
                          </a>
                        </li>
                      </ul>
                      <div class="tab-content b-0 mb-0">
                        <div class="tab-pane" style="display: block">
                          <div class="row">
                            <div class="col-12">
                              <company-info-tab
                                :activeTab="active_tab"
                                ref="companyInfoTabRef"
                                @privacy-policy-changed="privacyPolicyAccepted = !privacyPolicyAccepted"
                              />
                              <company-activity-tab :activeTab="active_tab" :user="user" ref="companyActivityTabRef" />
                            </div>
                          </div>
                        </div>

                        <ul class="list-inline wizard mb-0">
                          <li class="next list-inline-item float-end">
                            <base-button
                              v-show="active_tab === 1"
                              type="submit"
                              tabindex="9"
                              :disabled="$refs.companyInfoTabRef?.v$.$invalid || processing || !privacyPolicyAccepted"
                              >{{ $t('views.retailer.users.register.save_and_continue') }}</base-button
                            >
                            <base-button
                              v-show="active_tab === 2"
                              type="submit"
                              :disabled="nextTabDisabled || processing"
                              >{{ $t('views.retailer.users.register.save') }}</base-button
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </form>
                </template>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 text-center">
                <p class="text-muted">
                  <span v-if="active_tab !== RETAILER_REGISTER_STEP.COMPANY_ACTIVITY">{{
                    $t('views.retailer.users.register.already_have_an_account')
                  }}</span>
                  <router-link :to="{ name: 'panel-login' }" class="text-dark ms-1" @click="formClickSendEvent">
                    <b>{{ $t('views.retailer.users.register.login') }}</b>
                  </router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { useVuelidate } from '@vuelidate/core'
import Nprogress from 'nprogress'

import { event } from 'vue-gtag'

import store from '@/store/store.js'

import { COMPANY_TYPE } from '@/constants/companyType.js'
import { RETAILER_REGISTER_STEP } from '@/constants/retailerRegisterStep.js'

import BaseButton from '@/components/BaseButton.vue'
import BaseLogo from '@/components/BaseLogo.vue'
import GreenTeakIcon from '@/components/icons/GreenTeakIcon.vue'
import Loading from '@/components/Loading.vue'
import CompanyActivityTab from '@/views/retailer/users/components/registerComponents/companyActivityTab.vue'
import CompanyInfoTab from '@/views/retailer/users/components/registerComponents/companyInfoTab.vue'
import WelcomeCard from '@/views/retailer/users/components/registerComponents/welcomeCard.vue'

export default {
  components: {
    WelcomeCard,
    CompanyInfoTab,
    CompanyActivityTab,
    GreenTeakIcon,
    Loading,
    BaseButton,
    BaseLogo
  },
  data() {
    return {
      v$: useVuelidate(),
      RETAILER_REGISTER_STEP: RETAILER_REGISTER_STEP,
      active_tab: 1,
      retailerCompanyControl: false,
      nextTabDisabled: false,
      processing: false,
      isLoading: false,
      privacyPolicyAccepted: false
    }
  },
  methods: {
    formClickSendEvent() {
      event('form_actions', {
        event_action: 'form_clicked',
        form_name: 'Tarfin Yetkili Satış Noktası Kayıt'
      })
    },
    submit() {
      if (this.active_tab === RETAILER_REGISTER_STEP.COMPANY_INFO) {
        this.register()
      } else if (this.active_tab === RETAILER_REGISTER_STEP.COMPANY_ACTIVITY) {
        this.saveCompanyActivities()
      }
    },
    register() {
      this.retailerCompanyControl = true
      this.$refs.companyInfoTabRef.v$.$touch()
      if (this.$refs.companyInfoTabRef.v$.$invalid) {
        event('form_actions', {
          event_action: 'form_requested',
          form_name: 'Tarfin Yetkili Satış Noktası Kayıt'
        })

        store.dispatch('notification/add', {
          type: 'danger',
          message: this.$t('views.retailer.users.register.correct_faulty_fields_continue')
        })
        return
      }

      let registerParameter = this.$refs.companyInfoTabRef.retailer
      if (this.$refs.companyInfoTabRef.retailer.company_type.id === COMPANY_TYPE['SOLE_PROPRIETORSHIP']) {
        registerParameter.vkn = this.$refs.companyInfoTabRef.retailer.tckn
      } else {
        registerParameter.vkn = this.$refs.companyInfoTabRef.retailer.vkn
      }

      registerParameter = { ...registerParameter };
      delete registerParameter.tckn;

      Nprogress.start()
      this.processing = true

      this.$store
        .dispatch('retailerAuth/register', registerParameter)
        .then(() => {
          this.processing = false
          if (import.meta.env.MODE === 'production') {
            fbq('track', 'RetailerRegistered')
          }
        })
        .catch(() => {
          this.processing = false
        })
        .finally(() => {
          Nprogress.done()
        })
    },
    saveCompanyActivities() {
      this.$refs.companyActivityTabRef.v$.retailerAddress.$touch()
      this.$refs.companyActivityTabRef.$refs.questions.v$.answers.$touch()

      if (
        this.$refs.companyActivityTabRef.v$.retailerAddress.$invalid ||
        this.$refs.companyActivityTabRef.$refs.questions.v$.answers.$invalid
      ) {
        store.dispatch('notification/add', {
          type: 'danger',
          message: this.$t('views.retailer.users.register.correct_faulty_fields_continue')
        })
        return
      }

      Nprogress.start()
      this.processing = true

      let addressData = this.$refs.companyActivityTabRef.retailerAddress
      let answers = this.$refs.companyActivityTabRef.$refs.questions.answers

      event('form_actions', {
        event_action: 'form_requested',
        form_name: 'Tarfin Yetkili Satış Noktası Kayıt'
      })

      store
        .dispatch('retailerAuth/saveActivities', { address: addressData, answers: answers })
        .then(() => {
          this.processing = false
          this.$router.push({ name: 'retailer.dashboard' })
          if (import.meta.env.MODE === 'production') {
            fbq('track', 'RetailerSavedActivities')
          }
        })
        .catch(() => {
          this.processing = false
        })
        .finally(() => {
          Nprogress.done()
        })
    }
  },
  mounted() {
    if (import.meta.env.MODE === 'production') {
      fbq('init', '2689177078034135')
      fbq('init', '610504990474963')
      fbq('init', '985646805607572')
      fbq('track', 'PageView')
    }
    event('form_actions', {
      event_action: 'form_viewed',
      form_name: 'Tarfin Yetkili Satış Noktası Kayıt'
    })
  },
  created() {
    if (store.getters['retailerAuth/token']) {
      this.isLoading = true
      store
        .dispatch('retailerAuth/getUser')
        .then(user => {
          if (user) {
            this.active_tab = RETAILER_REGISTER_STEP.COMPANY_ACTIVITY
          }
          this.isLoading = false
        })
        .catch(() => {
          Nprogress.done()
          this.isLoading = false
        })
    }
    document
      .querySelector('meta[name="description"]')
      .setAttribute('content', this.$t('views.retailer.users.register.description'))
    document.title = this.$route.meta.title
  },
  computed: {
    ...mapState('retailerAuth', ['user'])
  },
  watch: {
    user: {
      handler(user) {
        if (user) {
          this.active_tab = RETAILER_REGISTER_STEP.COMPANY_ACTIVITY
        }

        if (user.retailer.address.neighborhood_id) {
          this.$router.push({ name: 'retailer.dashboard' })
        }
      },
      deep: true
    },
    active_tab() {
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style lang="scss">
textarea {
  resize: none;
}

.bg-spec {
  background-color: $gray-100;
}
</style>
